const Header = ({ children }: { children: React.ReactNode }) => {
  return (
    <h1 className="font-outfit text-white text-[20px]">
      <b>{children}</b>
    </h1>
  );
};

export default Header;
